'use client';

import { useEffect, useState } from 'react';
import { Feature, isEnabled } from '../utils/featureToggle';

export function hasQa() {
  return (
    isEnabled(Feature.storeQA) &&
    typeof window !== 'undefined' &&
    !(
      window.location.origin === 'https://athleticgreens.com' ||
      window.location.origin === 'https://drinkag1.com'
    )
  );
}

export function useHasQa() {
  const [hasQaValue, setHasQaValue] = useState(false);

  useEffect(() => {
    setHasQaValue(hasQa());
  }, []);

  return hasQaValue;
}
